import { Component, forwardRef, Host, OnInit, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { MasterService } from 'src/app/services/master.service';
import { DropdownFormControl } from 'src/app/shared/inputs/dropdown-form-control';
import { inputMgsErrs } from 'src/app/validators/message-validation';

@Component({
  selector: 'app-input-dp-district',
  templateUrl: './input-dp-district.component.html',
  styleUrls: ['./input-dp-district.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDpDistrictComponent),
      multi: true
    },
  ]
})
export class InputDpDistrictComponent extends DropdownFormControl implements OnInit {
  errors = inputMgsErrs.district;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private masterService: MasterService
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
    this.resetDropdownList();
  }

  initDropdownList(provinceId?: string): Promise<any> {
    return new Promise<any>(resolve => {
      this.resetDropdownList();
      this.masterService.getDistricts(provinceId).subscribe(result => {
        this.items.push(...result);
        this.findValueFromList(this.value);
        this.setAfterLoadItemDropdown();
        resolve('success');
      }, error => {
        resolve('error');
      });
    });
  }

  resetDropdownList() {
    this.items = new Array<DropdownModel>();
    // this.translate.get('input.dropdown.select.district').subscribe(label => {
    //   this.items.push({ value: null, label: label, data: null });
    // });
  }

}
